import {
    Box,
    Center,
    Container,
    Flex,
    Grid,
    GridItem,
    Image,
    List,
    Stack,
    Text,
} from "@chakra-ui/react";
import Head from "next/head";

import ModalRegistro from "@/components/inmobiliarias/ModalRegistro";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const cards = [
    {
        title: "Acceso Preferente",
        description:
            "Los miembros tienen acceso preferente a lanzamientos y preventas de desarrollos en exclusiva por Grupo Guía.",
        colorBar: "rgba(0, 59, 113, 1)",
    },
    {
        title: "Información en Tiempo Real",
        description: "Acceso a información actualizada sobre el inventario disponible.",
        colorBar: "rgba(16, 116, 207, 1)",
    },
    {
        title: "Registro de Clientes en Línea",
        description: "Registrar clientes en línea, las 24 horas del día, 7 días a la semana.",
        colorBar: "rgba(64, 137, 168, 1)",
    } /*, {
        title: 'Capacitaciones Personalizadas',
        description: 'Capacitaciones presenciales o virtuales para garantizar un desarrollo profesional continuo.',
        colorBar: 'rgba(25, 179, 244, 1)'
    }*/,
    {
        title: "Atención Personalizada",
        description:
            "Atención y seguimiento personalizado para satisfacer las necesidades individuales de los asesores y sus clientes.",
        colorBar: "rgba(255, 205, 0, 1)",
    },
    {
        title: "Capacitaciones y Certificaciones con Descuento",
        description:
            "Accede a capacitaciones y certificaciones presenciales o en línea a través de MENTOR con un 20% de descuento.",
        colorBar: "rgba(255, 168, 0, 1)",
    },
    {
        title: "Colaboración Profesional",
        description:
            "Colaboración con otros asesores y profesionales inmobiliarios, fomentando el intercambio de ideas, experiencias, inventario y requerimientos.",
        colorBar: "rgba(255, 122, 0, 1)",
    },
    {
        title: "Seguimiento a Posventa",
        description:
            "Seguimiento puntual a la posventa de las operaciones, asegurando la satisfacción completa de los clientes y una experiencia integral.",
        colorBar: "rgba(160, 93, 30, 1)",
    },
    {
        title: "Publicidad",
        description:
            "Los asesores podrán generar publicidad que busque una segmentación abierta con las propiedades a las que este programa les da acceso, con la limitante de no poder mencionar el nombre comercial del desarrollo, las marcas del desarrollador, constructor y/o de “Guia”",
        colorBar: "rgba(187, 161, 136, 1)",
    },
];

const GuiaBroker = () => {
    const validateIndex = (index) => {
        if (index % 2 === 0) {
            return "par";
        } else {
            return "impar";
        }
    };

    return (
        <>
            <Header />
            <Head>
                <title>Guia Broker</title>
            </Head>
            <Box w="full" mx="auto" maxW="3x1" paddingInline="0">
                <Flex
                    w="100%"
                    h="60vh"
                    id="fondo"
                    backgroundImage="url(https://media.grupoguia.mx/assets/home-page/guia-broker/bg-guiaBroker.webp)"
                    backgroundSize="cover"
                    backgroundPosition="center center"
                    backgroundRepeat="no-repeat"
                    position="relative"
                    p="0"
                    bgColor="gray.100"
                    borderRadius="10px"
                >
                    <Flex direction="column" w="100%" position="absolute" left="0" top="38%">
                        <Flex w="100%" justifyContent="center">
                            <Image
                                src="https://media.grupoguia.mx/assets/home-page/guia-broker/guiabroker.png"
                                width={{ base: "200", md: "380" }}
                                height="auto"
                                alt="guiaconectlogo"
                            />
                        </Flex>
                        <Stack
                            mt={16}
                            direction={{ base: "column", md: "row" }}
                            w="full"
                            maxW="6xl"
                            mx="auto"
                            align="center"
                            transitionDuration=".3s"
                            justifyContent="center"
                        >
                            <ModalRegistro guiaBroker={true} />
                        </Stack>
                    </Flex>
                </Flex>
            </Box>
            <Box mt={10} px={{ base: 4, md: 16 }}>
                <Container maxW="8xl">
                    <Box my={14}>
                        <Text mb={3} textAlign="center" fontWeight="700" fontSize="xl">
                            ¿Qué es Guia Brokers?
                        </Text>
                        <Text textAlign={{ base: "justify", md: "center" }}>
                            Guía Brokers una iniciativa desarrollada por Grupo Guía con el objetivo
                            de establecer colaboraciones estratégicas con asesores inmobiliarios
                            externos que cumplan con requisitos específicos y que deseen formar
                            parte de nuestra red de profesionales inmobiliarios. Este programa busca
                            fortalecer el gremio inmobiliario al facilitar una relación simbiótica
                            entre Grupo Guía y asesores externos altamente capacitados.
                        </Text>

                        <Text mt={14} mb={3} textAlign="center" fontWeight="700" fontSize="xl">
                            Los miembros del Programa Guía Brokers
                        </Text>
                        <Text textAlign={{ base: "justify", md: "center" }}>
                            Acceden a una serie de beneficios exclusivos que enriquecen su carrera y
                            les brindan ventajas competitivas:
                        </Text>

                        <Flex w="100%">
                            <Grid
                                mt={14}
                                mx={{ base: 1, md: 5, xl: 10 }}
                                w="100%"
                                templateColumns="repeat(2, 1fr)"
                                gap={9}
                            >
                                {cards.map((item, idx) => (
                                    <GridItem
                                        key={idx}
                                        minH="100px"
                                        mr={{
                                            base: "0px",
                                            xl: validateIndex(idx) === "par" ? "30px" : "0px",
                                        }}
                                        ml={{
                                            base: "0px",
                                            xl: validateIndex(idx) === "impar" ? "30px" : "0px",
                                        }}
                                        p={5}
                                        px={8}
                                        pl={10}
                                        borderWidth="2px"
                                        borderRadius="10px"
                                        position="relative"
                                    >
                                        <Box
                                            px="6px"
                                            h="65%"
                                            bg={item.colorBar}
                                            position="absolute"
                                            left="-6px"
                                            rounded="full"
                                        />
                                        <Text fontWeight="600">{item.title}:</Text>
                                        <Text>{item.description}</Text>
                                    </GridItem>
                                ))}
                            </Grid>
                        </Flex>

                        <Center my={24} mx={{ base: 0, md: 5, lg: 10, xl: 20 }}>
                            <Box display={{ base: "block", xl: "flex" }}>
                                <Image
                                    src="https://media.grupoguia.mx/assets/home-page/guia-broker/house.webp"
                                    alt="simple icon"
                                />
                                <Box ml={12} mt={8}>
                                    <Text fontWeight="700" fontSize="4xl">
                                        Forma parte de Guia Brokers
                                    </Text>
                                    <Text mb={8}>
                                        Solicita ser parte de guia brokers siguiendo los siguientes
                                        pasos:
                                    </Text>
                                </Box>
                            </Box>
                        </Center>

                        <Box my={20} mx={{ base: 3, md: 5, lg: 20 }}>
                            <Center>
                                <Flex w={{ base: "100%", md: "70%", lg: "50%" }}>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/icon-11.webp"
                                        display="inline-flex"
                                        width="auto"
                                        h="72px"
                                        marginRight={4}
                                        alt="simple icon"
                                    />
                                    <Box>
                                        <Text color="black" fontWeight={400}>
                                            <strong>1. Documentación:</strong>
                                            <br />
                                        </Text>
                                        <Text pt={2}>
                                            Ponte en contacto con el Guía Broker (Eduardo Luna) y
                                            compartir los siguientes documentos dando click{" "}
                                            <a
                                                href="https://share.hsforms.com/1ZIi-mLdTRq--0r5dndqpVw3j49k"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                }}
                                            >
                                                aquí
                                            </a>
                                        </Text>
                                    </Box>
                                </Flex>
                            </Center>
                            <Flex my={12} display={{ base: "block", md: "flex" }}>
                                <Box
                                    w={{ base: "100%", md: "40%" }}
                                    p={7}
                                    mr={5}
                                    borderWidth="1px"
                                    borderRadius="10px"
                                    borderColor="#BEBEBE"
                                >
                                    <Text fontWeight="700">Persona Física:</Text>
                                    <List.Root
                                        fontSize="md"
                                        color="black"
                                        fontWeight={400}
                                        mt={2}
                                        ml={6}
                                        gap="1.2"
                                    >
                                        <List.Item>
                                            CSF (certificado de situación fiscal) no mayor a 3
                                            meses.
                                        </List.Item>
                                        <List.Item>Opinión de Cumplimiento.</List.Item>
                                        <List.Item>
                                            Comprobante de Domicilio (no mayor a 3 meses).
                                        </List.Item>
                                        <List.Item>Identificación Oficial vigente.</List.Item>
                                        <List.Item>Caratula Bancaria con clabe.</List.Item>
                                        <List.Item>
                                            Contacto (nombre completo, correo, celular).
                                        </List.Item>
                                    </List.Root>
                                </Box>
                                <Box
                                    w={{ base: "100%", md: "60%" }}
                                    p={7}
                                    mt={{ base: 5, md: 0 }}
                                    ml={{ base: 0, md: 5 }}
                                    borderWidth="1px"
                                    borderRadius="10px"
                                    borderColor="#BEBEBE"
                                >
                                    <Text fontWeight="700">Persona Moral:</Text>
                                    <List.Root
                                        fontSize="md"
                                        color="black"
                                        fontWeight={400}
                                        mt={2}
                                        ml={6}
                                        gap="1.2"
                                    >
                                        <List.Item>
                                            CSF (certificado de situación fiscal) no mayor a 3
                                            meses.
                                        </List.Item>
                                        <List.Item>Opinión de Cumplimiento.</List.Item>
                                        <List.Item>
                                            Comprobante de Domicilio (no mayor a 3 meses).
                                        </List.Item>
                                        <List.Item>Identificación Oficial vigente.</List.Item>
                                        <List.Item>Caratula Bancaria con clabe.</List.Item>
                                        <List.Item>
                                            Datos del representante legal (nombre completo, correo,
                                            celular).
                                        </List.Item>
                                        <List.Item>
                                            Acta constitutiva de la empresa con Boleta Registral y
                                            poder del representante legal.
                                        </List.Item>
                                    </List.Root>
                                </Box>
                            </Flex>
                            <Center my={16}>
                                <Flex w={{ base: "100%", md: "80%", lg: "75%" }}>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/icon-12.webp"
                                        display="inline-flex"
                                        width="auto"
                                        h="72px"
                                        marginRight={8}
                                        alt="simple icon"
                                    />
                                    <Box>
                                        <Text color="black" fontWeight={400}>
                                            <strong>2. Convenio de autorización</strong>
                                            <br />
                                        </Text>
                                        <Text pt={2}>
                                            Una vez revisada la documentación que esté correcta y
                                            completa, se solicitará al área legal el convenio
                                            mercantil, éste tendrá vigencia de 1 año y será enviado
                                            para su firma digital, por FAD.
                                        </Text>
                                    </Box>
                                </Flex>
                            </Center>
                            <Center>
                                <Flex w={{ base: "100%", md: "80%", lg: "75%" }}>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/inventario.svg"
                                        display="inline-flex"
                                        width="72px"
                                        h="auto"
                                        marginRight={8}
                                        alt="simple icon"
                                    />
                                    <Box>
                                        <Text color="black" fontWeight={400}>
                                            <strong>3. Visualiza el inventario</strong>
                                            <br />
                                        </Text>
                                        <Text pt={2}>
                                            Una vez firmado el convenio, recibirás por correo un
                                            link en donde podrás tener el acceso al inventario de
                                            Grupo Guía y consultar la información que necesites. Es
                                            importante que en tu aplicación de pcloud o en tu correo
                                            electrónico aceptes la invitación, una vez hecho esto la
                                            carpeta se verá reflejada en tu cuenta de pcloud.
                                        </Text>
                                    </Box>
                                </Flex>
                            </Center>
                        </Box>

                        <Flex
                            mx={{ xl: 10 }}
                            display={{ base: "block", lg: "flex" }}
                            alignSelf="center"
                        >
                            {/* ====== MOBILE ====== */}
                            <Stack align="center">
                                <Flex display={{ base: "block", sm: "flex", lg: "none" }}>
                                    <Image
                                        mt={{ base: 5, sm: 32 }}
                                        mb={{ base: 5, sm: 0 }}
                                        h={{ base: "340px", sm: "280px" }}
                                        src="https://media.grupoguia.mx/assets/home-page/guia-broker/requisitos-permanencia-1.webp"
                                        alt="simple icon"
                                    />
                                    <Image
                                        pl={{ base: 0, sm: 5 }}
                                        w="auto"
                                        h="360px"
                                        src="https://media.grupoguia.mx/assets/home-page/guia-broker/requisitos-permanencia-2.webp"
                                        alt="simple icon"
                                    />
                                </Flex>
                            </Stack>
                            {/* ====== DESKTOP ====== */}
                            <Flex w="65em" display={{ base: "none", lg: "flex" }}>
                                <Image
                                    mt={32}
                                    h="280px"
                                    src="https://media.grupoguia.mx/assets/home-page/guia-broker/requisitos-permanencia-1.webp"
                                    alt="simple icon"
                                />
                                <Image
                                    pl={5}
                                    w="auto"
                                    h="360px"
                                    src="https://media.grupoguia.mx/assets/home-page/guia-broker/requisitos-permanencia-2.webp"
                                    alt="simple icon"
                                />
                            </Flex>
                            <Box mt={10} w="100%">
                                <Text fontWeight="700" fontSize="2xl">
                                    Requisitos de permanencia
                                </Text>
                                <Text fontSize="lg">
                                    Para mantener su membresía en el programa, los asesores deben
                                    cumplir con los siguientes requisitos:
                                </Text>

                                <Flex mt={10} ml={{ lg: 3 }}>
                                    <Image
                                        mr={5}
                                        my="auto"
                                        src="https://media.grupoguia.mx/assets/home-page/guia-broker/icon-participacion.png"
                                        w="auto"
                                        h="50px"
                                        alt="simple icon"
                                    />
                                    <Box>
                                        <Text fontWeight="700" fontSize="lg">
                                            Participación Activa:
                                        </Text>
                                        <Text>
                                            Se espera que los asesores participen activamente en los
                                            eventos, presentaciones y capacitaciones organizados por
                                            Grupo Guía para promover el crecimiento profesional y la
                                            actualización constante.
                                        </Text>
                                    </Box>
                                </Flex>
                            </Box>
                        </Flex>
                        <Text mt={28} textAlign="center">
                            *El registro de todos los clientes de Guía Brokers, será bajo el mismo
                            proceso ubicado en Soy Inmobiliaria.
                        </Text>
                        <Stack alignItems="center" mt={10}>
                            <Box>
                                <ModalRegistro guiaBroker={true} small={true} />
                            </Box>
                        </Stack>
                    </Box>
                </Container>
            </Box>
            <Footer visible={false} />
        </>
    );
};

export default GuiaBroker;
